// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3pqej","pending":"styles_pending__3BBRo"};